import { Symbols } from '@ioc/symbols'

import { ErrorMonitoring, useTryGetDependency } from '@writefull/core'

export default function useErrorMonitoring() {
  const errorMonitoring = useTryGetDependency<ErrorMonitoring>(Symbols.ERROR_MONITORING)
  return errorMonitoring
}
